import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HELP_CENTER_LINK } from 'constants/links';

const SearchHelpCenter = () => (
    <div className={'flex justify-end rounded-b-md bg-gray-50 p-2'}>
        <a
            href={HELP_CENTER_LINK}
            target="_blank"
            rel="noreferrer noopener"
            className={'flex w-fit items-center gap-1.5 text-blue-500'}
        >
            <FontAwesomeIcon size={'xs'} icon={faCircleQuestion} />
            <p className={'text-xs font-medium'}>Help Center</p>
        </a>
    </div>
);

export { SearchHelpCenter };
